import ExceptionIcon from '@jetbrains/icons/exception.svg'
import InfoIcon from '@jetbrains/icons/info.svg'
import SuccessIcon from '@jetbrains/icons/success.svg'
import WarningIcon from '@jetbrains/icons/warning.svg'
import type {ComponentType} from 'react'

import {type BannerAction, MessageType} from '../../../../contexts/Banners/BannersContext.types'

export type BannerProps = {
  id: string
  type: MessageType
  title?: string
  message: string
  closeable?: boolean
  actions?: BannerAction[]
}
export const bannerIcons: Record<MessageType, ComponentType> = {
  [MessageType.SUCCESS]: SuccessIcon,
  [MessageType.INFO]: InfoIcon,
  [MessageType.WARNING]: WarningIcon,
  [MessageType.ERROR]: ExceptionIcon,
}
